export type Country = 'MX' | 'BR' | 'PE'
export function isCountry(value: string): value is Country {
  return value === 'MX' || value === 'BR' || value === 'PE'
}
